import store from '../store'

export default function (toast = {}) {
    store.dispatch('addToast', toast)
}
